/** TODO: Move this component to UI Library */
import React, { useId } from 'react';
import PropTypes from 'prop-types';
import './banner.scss';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

const Banner = ({
  body,
  actionLabel,
  onAction,
  icon,
  variant = 'warning',
  className = '',
  actionButtonClassName = ''
}) => {
  const descriptionId = useId();

  return (
    <div
      role="alert"
      aria-describedby={body ? descriptionId : undefined}
      className={`banner ${variant} ${className}`}
    >
      <div className="bannerContentWrapper">
        <div className="bannerContent">
          <div className="bannerTop">
            {icon && (
              <div
                className="bannerIcon"
                aria-hidden="true"
              >
                <Icon icon={icon} />
              </div>
            )}

            <div className="bannerText">
              {body && (
                <div
                  id={descriptionId}
                  className="bannerBody"
                >
                  {body}
                </div>
              )}
            </div>
          </div>
          {actionLabel && onAction && (
            <div className="bannerAction">
              <button
                type="button"
                className={`button primary ${actionButtonClassName}`.trim()}
                onClick={onAction}
              >
                <span>{actionLabel}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  body: PropTypes.node,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  icon: PropTypes.string,
  variant: PropTypes.oneOf(['warning', 'info', 'success', 'error']),
  className: PropTypes.string,
  actionButtonClassName: PropTypes.string
};

export default Banner;
